import React from "react";

const LearnEveryDayTopBGElement = () => {
  return (
    <svg
      width="68"
      height="84"
      viewBox="0 0 68 84"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6476_35650)">
        <path
          d="M68 0C68 -15.464 55.464 -28 40 -28C24.536 -28 12 -15.464 12 0V28C12 58.9279 37.0721 84 68 84V0Z"
          fill="white"
          fillOpacity="0.04"
        />
        <path
          d="M56 -12C56 -27.464 43.464 -40 28 -40C12.536 -40 0 -27.464 0 -12V16C0 46.9279 25.0721 72 56 72V-12Z"
          fill="white"
          fillOpacity="0.04"
        />
      </g>
      <defs>
        <clipPath id="clip0_6476_35650">
          <rect width="68" height="84" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LearnEveryDayTopBGElement;
